<script setup lang="ts">
import type { PropType } from 'vue'
import type { AdminConfiguratorType } from '@/entities/Cabinet'
import { useModelTable } from './../model/model'
import { VIcons, VModal } from '@/shared/ui'
import './assets/style.scss'
import {
  AdminConfiguratorTemplateButton,
  AdminConfiguratorTemplateDelete,
  AdminConfiguratorTemplateUse,
} from '@/features/Cabinet/AdminConfiguratorTemplate'

defineProps({
  configs: {
    type: Array as PropType<AdminConfiguratorType[]>,
    required: true,
  },
})

const model = useModelTable()

const { isPending } = model.loadTable()
</script>

<template>
  <VModal v-model="model.open" :max-width="780">
    <template #title>
      <div class="templates__header">
        {{ $t('itf.templates') }}

        <div class="templates__buttons">
          <AdminConfiguratorTemplateButton :configs :events="model.events">
            <VBtn icon density="compact" variant="tonal">
              <VIcons type="upload" />
            </VBtn>
          </AdminConfiguratorTemplateButton>

          <AdminConfiguratorTemplateButton>
            <VBtn icon density="compact" variant="tonal" color="secondary">
              <VIcons type="add" />
            </VBtn>
          </AdminConfiguratorTemplateButton>
        </div>
      </div>
    </template>

    <VDataTable
      :loading="isPending"
      :items="model.templates"
      hide-default-footer
      :items-per-page="-1"
      :headers="model.headers"
    >
      <template v-slot:item.action="{ item }">
        <div class="template__buttons">
          <AdminConfiguratorTemplateUse :template="item">
            <VBtn icon color="secondary" density="compact">
              <VIcons type="check" />
            </VBtn>
          </AdminConfiguratorTemplateUse>

          <AdminConfiguratorTemplateButton :item>
            <VBtn icon density="compact">
              <VIcons type="settings" />
            </VBtn>
          </AdminConfiguratorTemplateButton>

          <AdminConfiguratorTemplateDelete :item />
        </div>
      </template>
    </VDataTable>

    <div class="mt-2 form__btn_right">
      <VBtn color="default" @click="model.open = false">{{ $t('itf.close') }}</VBtn>
    </div>
  </VModal>

  <VBtn color="default" variant="tonal" @click="model.open = true">{{ $t('itf.templates') }}</VBtn>
</template>
